[
  {
    "code": "SI-001",
    "name": "Ajdovšcina"
  },
  {
    "code": "SI-002",
    "name": "Beltinci"
  },
  {
    "code": "SI-148",
    "name": "Benedikt"
  },
  {
    "code": "SI-149",
    "name": "Bistrica ob Sotli"
  },
  {
    "code": "SI-003",
    "name": "Bled"
  },
  {
    "code": "SI-150",
    "name": "Bloke"
  },
  {
    "code": "SI-004",
    "name": "Bohinj"
  },
  {
    "code": "SI-005",
    "name": "Borovnica"
  },
  {
    "code": "SI-006",
    "name": "Bovec"
  },
  {
    "code": "SI-151",
    "name": "Braslovce"
  },
  {
    "code": "SI-007",
    "name": "Brda"
  },
  {
    "code": "SI-008",
    "name": "Brezovica"
  },
  {
    "code": "SI-009",
    "name": "Brežice"
  },
  {
    "code": "SI-152",
    "name": "Cankova"
  },
  {
    "code": "SI-011",
    "name": "Celje (urbane commune)"
  },
  {
    "code": "SI-012",
    "name": "Cerklje na Gorenjskem"
  },
  {
    "code": "SI-013",
    "name": "Cerknica"
  },
  {
    "code": "SI-014",
    "name": "Cerkno"
  },
  {
    "code": "SI-153",
    "name": "Cerkvenjak"
  },
  {
    "code": "SI-015",
    "name": "Crenšovci"
  },
  {
    "code": "SI-016",
    "name": "Crna na Koroškem"
  },
  {
    "code": "SI-017",
    "name": "Crnomelj"
  },
  {
    "code": "SI-018",
    "name": "Destrnik"
  },
  {
    "code": "SI-019",
    "name": "Divaca"
  },
  {
    "code": "SI-154",
    "name": "Dobje"
  },
  {
    "code": "SI-020",
    "name": "Dobrepolje"
  },
  {
    "code": "SI-155",
    "name": "Dobrna"
  },
  {
    "code": "SI-021",
    "name": "Dobrova-Horjul-Polhov Gradec"
  },
  {
    "code": "SI-156",
    "name": "Dobrovnik"
  },
  {
    "code": "SI-022",
    "name": "Dol pri Ljubljani"
  },
  {
    "code": "SI-157",
    "name": "Dolenjske Toplice"
  },
  {
    "code": "SI-023",
    "name": "Domžale"
  },
  {
    "code": "SI-024",
    "name": "Dornava"
  },
  {
    "code": "SI-025",
    "name": "Dravograd"
  },
  {
    "code": "SI-026",
    "name": "Duplek"
  },
  {
    "code": "SI-027",
    "name": "Gorenja vas-Poljane"
  },
  {
    "code": "SI-028",
    "name": "Gorišnica"
  },
  {
    "code": "SI-029",
    "name": "Gornja Radgona"
  },
  {
    "code": "SI-030",
    "name": "Gornji Grad"
  },
  {
    "code": "SI-031",
    "name": "Gornji Petrovci"
  },
  {
    "code": "SI-158",
    "name": "Grad"
  },
  {
    "code": "SI-032",
    "name": "Grosuplje"
  },
  {
    "code": "SI-159",
    "name": "Hajdina"
  },
  {
    "code": "SI-160",
    "name": "Hoce-Slivnica"
  },
  {
    "code": "SI-161",
    "name": "Hodoš"
  },
  {
    "code": "SI-162",
    "name": "Horjul"
  },
  {
    "code": "SI-034",
    "name": "Hrastnik"
  },
  {
    "code": "SI-035",
    "name": "Hrpelje-Kozina"
  },
  {
    "code": "SI-036",
    "name": "Idrija"
  },
  {
    "code": "SI-037",
    "name": "Ig"
  },
  {
    "code": "SI-038",
    "name": "Ilirska Bistrica"
  },
  {
    "code": "SI-039",
    "name": "Ivancna Gorica"
  },
  {
    "code": "SI-040",
    "name": "Izola/Isola"
  },
  {
    "code": "SI-041",
    "name": "Jesenice"
  },
  {
    "code": "SI-163",
    "name": "Jezersko"
  },
  {
    "code": "SI-042",
    "name": "Juršinci"
  },
  {
    "code": "SI-043",
    "name": "Kamnik"
  },
  {
    "code": "SI-044",
    "name": "Kanal"
  },
  {
    "code": "SI-045",
    "name": "Kidricevo"
  },
  {
    "code": "SI-046",
    "name": "Kobarid"
  },
  {
    "code": "SI-047",
    "name": "Kobilje"
  },
  {
    "code": "SI-048",
    "name": "Kocevje"
  },
  {
    "code": "SI-049",
    "name": "Komen"
  },
  {
    "code": "SI-164",
    "name": "Komenda"
  },
  {
    "code": "SI-050",
    "name": "Koper/Capodistria (urbane commune)"
  },
  {
    "code": "SI-165",
    "name": "Kostel"
  },
  {
    "code": "SI-051",
    "name": "Kozje"
  },
  {
    "code": "SI-052",
    "name": "Kranj (urbane commune)"
  },
  {
    "code": "SI-053",
    "name": "Kranjska Gora"
  },
  {
    "code": "SI-166",
    "name": "Križevci"
  },
  {
    "code": "SI-054",
    "name": "Krško"
  },
  {
    "code": "SI-055",
    "name": "Kungota"
  },
  {
    "code": "SI-056",
    "name": "Kuzma"
  },
  {
    "code": "SI-057",
    "name": "Laško"
  },
  {
    "code": "SI-058",
    "name": "Lenart"
  },
  {
    "code": "SI-059",
    "name": "Lendava"
  },
  {
    "code": "SI-060",
    "name": "Litija"
  },
  {
    "code": "SI-061",
    "name": "Ljubljana (urbane commune)"
  },
  {
    "code": "SI-062",
    "name": "Ljubno"
  },
  {
    "code": "SI-063",
    "name": "Ljutomer"
  },
  {
    "code": "SI-064",
    "name": "Logatec"
  },
  {
    "code": "SI-167",
    "name": "Lovrenc na Pohorju"
  },
  {
    "code": "SI-065",
    "name": "Loška Dolina"
  },
  {
    "code": "SI-066",
    "name": "Loški Potok"
  },
  {
    "code": "SI-067",
    "name": "Luce"
  },
  {
    "code": "SI-068",
    "name": "Lukovica"
  },
  {
    "code": "SI-069",
    "name": "Majšperk"
  },
  {
    "code": "SI-070",
    "name": "Maribor (urbane commune)"
  },
  {
    "code": "SI-168",
    "name": "Markovci"
  },
  {
    "code": "SI-071",
    "name": "Medvode"
  },
  {
    "code": "SI-072",
    "name": "Mengeš"
  },
  {
    "code": "SI-073",
    "name": "Metlika"
  },
  {
    "code": "SI-074",
    "name": "Mežica"
  },
  {
    "code": "SI-169",
    "name": "Miklavž na Dravskem Polju"
  },
  {
    "code": "SI-075",
    "name": "Miren-Kostanjevica"
  },
  {
    "code": "SI-170",
    "name": "Mirna Pec"
  },
  {
    "code": "SI-076",
    "name": "Mislinja"
  },
  {
    "code": "SI-077",
    "name": "Moravce"
  },
  {
    "code": "SI-078",
    "name": "Moravske Toplice"
  },
  {
    "code": "SI-079",
    "name": "Mozirje"
  },
  {
    "code": "SI-080",
    "name": "Murska Sobota (urbane commune)"
  },
  {
    "code": "SI-081",
    "name": "Muta"
  },
  {
    "code": "SI-082",
    "name": "Naklo"
  },
  {
    "code": "SI-083",
    "name": "Nazarje"
  },
  {
    "code": "SI-084",
    "name": "Nova Gorica (urbane commune)"
  },
  {
    "code": "SI-085",
    "name": "Novo Mesto (urbane commune)"
  },
  {
    "code": "SI-086",
    "name": "Odranci"
  },
  {
    "code": "SI-171",
    "name": "Oplotnica"
  },
  {
    "code": "SI-087",
    "name": "Ormož"
  },
  {
    "code": "SI-088",
    "name": "Osilnica"
  },
  {
    "code": "SI-089",
    "name": "Pesnica"
  },
  {
    "code": "SI-090",
    "name": "Piran"
  },
  {
    "code": "SI-091",
    "name": "Pivka"
  },
  {
    "code": "SI-092",
    "name": "Podcetrtek"
  },
  {
    "code": "SI-172",
    "name": "Podlehnik"
  },
  {
    "code": "SI-093",
    "name": "Podvelka"
  },
  {
    "code": "SI-173",
    "name": "Polzela"
  },
  {
    "code": "SI-094",
    "name": "Postojna"
  },
  {
    "code": "SI-174",
    "name": "Prebold"
  },
  {
    "code": "SI-095",
    "name": "Preddvor"
  },
  {
    "code": "SI-175",
    "name": "Prevalje"
  },
  {
    "code": "SI-096",
    "name": "Ptuj (urbane commune)"
  },
  {
    "code": "SI-097",
    "name": "Puconci"
  },
  {
    "code": "SI-098",
    "name": "Race-Fram"
  },
  {
    "code": "SI-099",
    "name": "Radece"
  },
  {
    "code": "SI-100",
    "name": "Radenci"
  },
  {
    "code": "SI-101",
    "name": "Radlje ob Dravi"
  },
  {
    "code": "SI-102",
    "name": "Radovljica"
  },
  {
    "code": "SI-103",
    "name": "Ravne na Koroškem"
  },
  {
    "code": "SI-176",
    "name": "Razkrižje"
  },
  {
    "code": "SI-104",
    "name": "Ribnica"
  },
  {
    "code": "SI-177",
    "name": "Ribnica na Pohorju"
  },
  {
    "code": "SI-107",
    "name": "Rogatec"
  },
  {
    "code": "SI-106",
    "name": "Rogaška Slatina"
  },
  {
    "code": "SI-105",
    "name": "Rogašovci"
  },
  {
    "code": "SI-108",
    "name": "Ruše"
  },
  {
    "code": "SI-178",
    "name": "Selnica ob Dravi"
  },
  {
    "code": "SI-109",
    "name": "Semic"
  },
  {
    "code": "SI-110",
    "name": "Sevnica"
  },
  {
    "code": "SI-111",
    "name": "Sežana"
  },
  {
    "code": "SI-112",
    "name": "Slovenj Gradec (urbane commune)"
  },
  {
    "code": "SI-113",
    "name": "Slovenska Bistrica"
  },
  {
    "code": "SI-114",
    "name": "Slovenske Konjice"
  },
  {
    "code": "SI-179",
    "name": "Sodražica"
  },
  {
    "code": "SI-180",
    "name": "Solcava"
  },
  {
    "code": "SI-115",
    "name": "Starše"
  },
  {
    "code": "SI-181",
    "name": "Sveta Ana"
  },
  {
    "code": "SI-182",
    "name": "Sveti Andraž v Slovenskih Goricah"
  },
  {
    "code": "SI-116",
    "name": "Sveti Jurij"
  },
  {
    "code": "SI-184",
    "name": "Tabor"
  },
  {
    "code": "SI-010",
    "name": "Tišina"
  },
  {
    "code": "SI-128",
    "name": "Tolmin"
  },
  {
    "code": "SI-129",
    "name": "Trbovlje"
  },
  {
    "code": "SI-130",
    "name": "Trebnje"
  },
  {
    "code": "SI-185",
    "name": "Trnovska Vas"
  },
  {
    "code": "SI-186",
    "name": "Trzin"
  },
  {
    "code": "SI-131",
    "name": "Tržic"
  },
  {
    "code": "SI-132",
    "name": "Turnišce"
  },
  {
    "code": "SI-133",
    "name": "Velenje (urbane commune)"
  },
  {
    "code": "SI-187",
    "name": "Velika Polana"
  },
  {
    "code": "SI-134",
    "name": "Velike Lašce"
  },
  {
    "code": "SI-188",
    "name": "Veržej"
  },
  {
    "code": "SI-135",
    "name": "Videm"
  },
  {
    "code": "SI-136",
    "name": "Vipava"
  },
  {
    "code": "SI-137",
    "name": "Vitanje"
  },
  {
    "code": "SI-138",
    "name": "Vodice"
  },
  {
    "code": "SI-139",
    "name": "Vojnik"
  },
  {
    "code": "SI-189",
    "name": "Vransko"
  },
  {
    "code": "SI-140",
    "name": "Vrhnika"
  },
  {
    "code": "SI-141",
    "name": "Vuzenica"
  },
  {
    "code": "SI-142",
    "name": "Zagorje ob Savi"
  },
  {
    "code": "SI-143",
    "name": "Zavrc"
  },
  {
    "code": "SI-144",
    "name": "Zrece"
  },
  {
    "code": "SI-033",
    "name": "Šalovci"
  },
  {
    "code": "SI-183",
    "name": "Šempeter-Vrtojba"
  },
  {
    "code": "SI-117",
    "name": "Šencur"
  },
  {
    "code": "SI-118",
    "name": "Šentilj"
  },
  {
    "code": "SI-119",
    "name": "Šentjernej"
  },
  {
    "code": "SI-120",
    "name": "Šentjur pri Celju"
  },
  {
    "code": "SI-121",
    "name": "Škocjan"
  },
  {
    "code": "SI-122",
    "name": "Škofja Loka"
  },
  {
    "code": "SI-123",
    "name": "Škofljica"
  },
  {
    "code": "SI-124",
    "name": "Šmarje pri Jelšah"
  },
  {
    "code": "SI-125",
    "name": "Šmartno ob Paki"
  },
  {
    "code": "SI-194",
    "name": "Šmartno pri Litiji"
  },
  {
    "code": "SI-126",
    "name": "Šoštanj"
  },
  {
    "code": "SI-127",
    "name": "Štore"
  },
  {
    "code": "SI-190",
    "name": "Žalec"
  },
  {
    "code": "SI-146",
    "name": "Železniki"
  },
  {
    "code": "SI-191",
    "name": "Žetale"
  },
  {
    "code": "SI-147",
    "name": "Žiri"
  },
  {
    "code": "SI-192",
    "name": "Žirovnica"
  },
  {
    "code": "SI-193",
    "name": "Žužemberk"
  }
]